import React from 'react';
import { Tooltip, Box } from '@mui/material';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';

/**
 * Wraps a button/IconButton with a tooltip when disabled
 * Shows DoDisturbIcon and "Read-only mode" message on hover
 * 
 * @param {Object} props
 * @param {React.ReactNode} props.children - The button/IconButton to wrap
 * @param {boolean} props.isDisabled - Whether the button is disabled
 * @param {string} [props.tooltipText="Read-only mode: This action is disabled"] - Custom tooltip text
 * @returns {React.ReactNode}
 */
export default function DisabledButtonWrapper({ 
  children, 
  isDisabled, 
  tooltipText = "Read-only mode: This action is disabled" 
}) {
  // If not disabled, render children as-is (no wrapper needed)
  if (!isDisabled) {
    return <>{children}</>;
  }

  // If disabled, wrap with tooltip
  return (
    <Tooltip
      title={
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <DoDisturbIcon fontSize="small" />
          <span>{tooltipText}</span>
        </Box>
      }
      arrow
      placement="top"
    >
      <Box component="span" sx={{ display: 'inline-block' }}>
        {children}
      </Box>
    </Tooltip>
  );
}


